import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./style/_newform.scss";

interface INewFormProps extends React.HTMLProps<HTMLElement>{
  title?:string;
  more?:React.HTMLProps<HTMLElement>;
  disabled?:boolean;
}

function NewForm({
  children,
  title,
  className,
  more,
  disabled
}:INewFormProps){
  return (
    <Container>
      {disabled?<></>:(
        <Form className={"newform"+(className?" "+className:"")}>
          <Row className={"row-title justify-content-between"+(!title && !more?" mt-3":"")}>
            {title?(<Col xs={"auto"} className="align-self-center"><h4>{title}</h4></Col>):""}
            {more?<Col xs={"auto"} className="align-self-center">{more}</Col>:""}
          </Row>
          <Row>
            {children}
          </Row>
        </Form>
      )}
    </Container>
  );
}

export default Object.assign(NewForm, {
  Input: require("./FormInput").default,
  InputNumber: require("./FormInputNumber").default,
  Select: require("./FormSelect").default,
  SelectSearch: require("./FormSelectSearch").default,
  InputMoney: require("./FormInputMoney").default,
  Textarea: require("./FormTextarea").default,
  Date: require("./FormInputDate").default,
  Files: require("./FormInputFiles").default,
});